import React from "react";
import { ButtonBg } from "./ButtonBg";
import { Link, useParams } from "react-router-dom";
import { Loading } from "./Loading";

export const KeypointCart = ({ keypoint, length }) => {
  const { id } = useParams();
  const keypointId = +keypoint?.order + 1;

  return (
    <>
      {!keypoint || !id ? (
        <div className="flex">
          <Loading />
        </div>
      ) : (
        <div className="relative bg-gray-200 h-[550px] min-h-max mt-10 rounded-2xl p-6 overflow-hidden sm:p-8 sm:h-[450px] md:h-[500px]">
          <div className="w-full min-h-full sm:mb-16 md:mb-20">
            <div className="flex justify-between mb-8 h-[150px] flex-col sm:flex-row sm:h-[90px] md:h-[100px]">
              <h2 className="text-2xl font-semibold text-center text-gray-950 sm:text-3xl sm:w-[90%] sm:text-left">
                Keypoint {keypointId}: {keypoint?.name}
              </h2>
              <span className="text-2xl font-semibold mt-5 text-center sm:mt-0 sm:text-2xl sm:text-left">
                {keypointId}/{length}
              </span>
            </div>

            <div
              className="text-xl min-h-fit h-[196px] overflow-hidden text-ellipsis sm:text-2xl"
              dangerouslySetInnerHTML={{ __html: keypoint.summary }}
            />

            <Link
              to={`/books/${id}/keypoint_${keypointId}`}
              className="absolute right-[20%] left-[20%] bottom-11 w-[60%] mb-0 md:w-auto md:right-8 md:left-auto"
            >
              <ButtonBg text="Read more >" classes="mb-0 w-full" />
            </Link>
          </div>
        </div>
      )}
    </>
  );
};
